const cognitoConfig = {
  localhost: {
    REGION: "eu-west-1",
    USER_POOL_ID: "eu-west-1_1leV1n7cn",
    APP_CLIENT_ID: "gn4irfgh32rirc4rsp6mg9dnd",
    IDENTITY_POOL_ID: "eu-west-1:10a37f1a-da52-4678-b3a5-905890d22930"
  },
  beta: {
    REGION: "eu-west-1",
    USER_POOL_ID: "eu-west-1_1leV1n7cn",
    APP_CLIENT_ID: "gn4irfgh32rirc4rsp6mg9dnd",
    IDENTITY_POOL_ID: "eu-west-1:10a37f1a-da52-4678-b3a5-905890d22930"
  },
  gamma: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_icqBQG9OT",
    APP_CLIENT_ID: "74po3rlqmlvgmjikevgfjkgpn1",
    IDENTITY_POOL_ID: "us-east-1:2ab017e4-ffbf-400e-a1c4-83cc64f8ac31"
  },
  prod: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_sHCzgRtID",
    APP_CLIENT_ID: "5ct56b0c2dof85f12poo8j5m5d",
    IDENTITY_POOL_ID: "us-east-1:4602125a-f452-4c6e-9d29-3b76ea5343f4"
  },
};

export default cognitoConfig;